export function back_to_top() {
  $('#back-to-top').click(function (e) {
    e.preventDefault();

    $('body,html').animate({
      scrollTop: 0,
    }, 1000);
    return false;
  });

  $(window).scroll(function () {
    if ($(this).scrollTop() > 250) {
      $('#back-to-top').fadeIn();
    } else {
      $('#back-to-top').fadeOut();
    }
  });
}



// WEBPACK FOOTER //
// ./scripts/components/back-to-top.js